import React from 'react';
import Card from './Card';
import { formatAmount } from '../../../Common/utils';

const Header = ({ balance, incomes, outcomes, operationsCount, futureReleases }) => {
  return (
    <div className="header bg-gradient-danger pb-8 pt-5 pt-md-8">
      <div className="container-fluid">
        <div className="header-body">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <Card
                title="Saldo"
                count={formatAmount(balance)}
                color="bg-success"
                icon="fas fa-chart-pie"
              />
            </div>
            <div className="col-xl-6 col-lg-6">
              <Card
                title="Lançamentos Futuros"
                count={formatAmount(futureReleases)}
                color="bg-info"
                icon="fas fa-calculator"
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xl-4 col-lg-6">
              <Card
                title="Entradas"
                count={formatAmount(incomes)}
                color="bg-success"
                icon="fas fa-chart-bar"
              />
            </div>
            <div className="col-xl-4 col-lg-6">
              <Card
                title="Saídas"
                count={formatAmount(outcomes)}
                color="bg-danger"
                icon="fas fa-chart-pie"
              />
            </div>
            <div className="col-xl-4 col-lg-6">
              <Card
                title="Operações Finalizadas"
                count={operationsCount}
                color="bg-default"
                icon="fas fa-percent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/Header.js